export enum AutomatedConfigTypeEnum {
  ELAC_PROFORMA = 'elacProForma',
  XO_DEDICATED_FLEET = 'xoDedicatedFleet',
}
